
import moment from "moment";
import { FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";


export async function actualizarOrdenDetallePedido(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/detalle-pedido/actualizar-orden-detalle-pedido",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("habilitarPais err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerListaDetallePedido(obj, tag) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/detalle-pedido/obtener-lista-detalle-pedido",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.data = body;
            for (let i = 0; i < data.data.length; i++) {
                data.data[i].fechaProcesoWorkflow = moment(data.data[i].fechaProcesoWorkflow).format("YYYY/MM/DD HH:mm");
                data.data[i].finalizadoLabel = data.data[i].finalizado === 1 ? tag("column_si") : tag("column_no");
                data.data[i].coordenadasCliente = data.data[i].latitudCliente + "," + data.data[i].longitudCliente;
                data.data[i].coordenadasInicioAtencion = data.data[i].latitudInicio + "," + data.data[i].longitudInicio;
                data.data[i].coordenadasFinAtencion = "";
                if (data.data[i].latitudFin !== null && data.data[i].longitudFin !== null) {
                    data.data[i].coordenadasFinAtencion = data.data[i].latitudFin + "," + data.data[i].longitudFin;
                }
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerListaDetallePedido err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerTodaInformacionDetallePedido(obj, tag) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/detalle-pedido/obtener-toda-informacion-detalle-pedido",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.data = body;
            for (let i = 0; i < data.data.length; i++) {
                let fechaProcesoWorkflow = data.data[i].fechaProcesoWorkflow;
                // console.log('fechaProcesoWorkflow');
                // console.log(fechaProcesoWorkflow);
                if (fechaProcesoWorkflow !== undefined && fechaProcesoWorkflow !== null && moment(fechaProcesoWorkflow).isValid() === true) {
                    fechaProcesoWorkflow = moment(fechaProcesoWorkflow).format("YYYY/MM/DD HH:mm");
                }
                let fechaEntregaProgramada = data.data[i].fechaEntregaProgramada;
                if (fechaEntregaProgramada !== undefined && fechaEntregaProgramada !== null && moment(fechaEntregaProgramada).isValid() === true) {
                    fechaEntregaProgramada = moment(fechaEntregaProgramada).format("YYYY/MM/DD");
                }
                let fechaProgramacionSalida = data.data[i].fechaProgramacionSalida;
                if (fechaProgramacionSalida !== undefined && fechaProgramacionSalida !== null && moment(fechaProgramacionSalida).isValid() === true) {
                    fechaProgramacionSalida = moment(fechaProgramacionSalida).format("YYYY/MM/DD");
                }
                let fechaCarguio = data.data[i].fechaCarguio;
                if (fechaCarguio !== undefined && fechaCarguio !== null && moment(fechaCarguio).isValid() === true) {
                    fechaCarguio = moment(fechaCarguio).format("YYYY/MM/DD");
                }
                let fechaEntregaExcel = data.data[i].fechaEntregaExcel;
                if (fechaEntregaExcel !== undefined && fechaEntregaExcel !== null && moment(fechaEntregaExcel).isValid() === true) {
                    fechaEntregaExcel = moment(fechaEntregaExcel).format("YYYY/MM/DD");
                }

                data.data[i].fechaEntregaProgramada = fechaEntregaProgramada;
                data.data[i].fechaEntregaExcel = fechaEntregaExcel;
                data.data[i].fechaCarguio = fechaCarguio;
                data.data[i].fechaProgramacionSalida = fechaProgramacionSalida;
                data.data[i].fechaProcesoWorkflow = fechaProcesoWorkflow;
                data.data[i].finalizadoLabel = data.data[i].finalizado === 1 ? tag("column_si") : tag("column_no");
                data.data[i].coordenadasCliente = data.data[i].latitudCliente + "," + data.data[i].longitudCliente;
                data.data[i].coordenadasInicioAtencion = data.data[i].latitudInicio + "," + data.data[i].longitudInicio;
                data.data[i].coordenadasFinAtencion = "";
                if (data.data[i].latitudFin !== null && data.data[i].longitudFin !== null) {
                    data.data[i].coordenadasFinAtencion = data.data[i].latitudFin + "," + data.data[i].longitudFin;
                }
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerListaDetallePedido err");
        console.log(err);
        return { error: true, message: err };
    }
}